import { jsapiTicket } from "@/common/api";

let url = window.location.href.split("#")[0];


export default {
  namespaced: true,

  state: {
    isReady: false
  },

  mutations: {
    isReadyChange(state, status) {
      state.isReady = status
    }
  },

  actions: {
    wxSdkConfig({state, commit}) {
      console.log(state.isReady, 'state.isReady');
      // if (state.isReady) {
      //   return
      // }
      
      jsapiTicket({url})
        .then((res) => {
          console.log('-----接口的返回----')
          console.log(res)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: "wxc1ca3bce1945503b", //必填，公众号的唯一标识
            nonceStr: res.noncestr, // 必填，生成签名的随机串
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            signature: res.signature, //// 必填，签名
            openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表
            jsApiList: ["chooseImage"], // 必填，需要使用的JS接口列表
          });

          wx.ready(function () {
            console.log("wx config ready");
            commit('isReadyChange', true)
          });
          wx.error(function (err) {
            console.log("wx config error");
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            // alert("初始化失败",err)
          });
        });
    }
  }
}
